export default "__VITE_ASSET__d7ea59de__"